var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoresult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 104,
    viewBox: "0 0 176 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.963 23.5625C100.113 23.5625 102.667 26.1089 102.667 29.25C102.667 32.3911 100.113 34.9375 96.963 34.9375H149.111C152.261 34.9375 154.815 37.4839 154.815 40.625C154.815 43.7661 152.261 46.3125 149.111 46.3125H167.037C170.187 46.3125 172.741 48.8589 172.741 52C172.741 55.1411 170.187 57.6875 167.037 57.6875H151.556C148.405 57.6875 145.852 60.2339 145.852 63.375C145.852 66.5161 148.405 69.0625 151.556 69.0625H156.444C159.595 69.0625 162.148 71.6089 162.148 74.75C162.148 77.8911 159.595 80.4375 156.444 80.4375H114.074C113.655 80.4375 113.246 80.3923 112.852 80.3066C112.458 80.3923 112.049 80.4375 111.63 80.4375H37.4815C34.3314 80.4375 31.7778 77.8911 31.7778 74.75C31.7778 71.6089 34.3314 69.0625 37.4815 69.0625H5.7037C2.55364 69.0625 0 66.5161 0 63.375C0 60.2339 2.55364 57.6875 5.7037 57.6875H38.2963C41.4464 57.6875 44 55.1411 44 52C44 48.8589 41.4464 46.3125 38.2963 46.3125H17.9259C14.7759 46.3125 12.2222 43.7661 12.2222 40.625C12.2222 37.4839 14.7759 34.9375 17.9259 34.9375H50.5185C47.3685 34.9375 49.677 32.3911 49.677 29.25C49.677 26.1089 54.4016 24.6425 57.5516 24.6425L96.963 23.5625ZM170.296 69.0625C173.446 69.0625 176 71.6089 176 74.75C176 77.8911 173.446 80.4375 170.296 80.4375C167.146 80.4375 164.593 77.8911 164.593 74.75C164.593 71.6089 167.146 69.0625 170.296 69.0625Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0222 90.675C110.783 90.675 130.044 71.468 130.044 47.775C130.044 24.082 110.783 4.875 87.0222 4.875C63.2617 4.875 44 24.082 44 47.775C44 71.468 63.2617 90.675 87.0222 90.675Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.294 98.3823L114.718 81.6484",
    stroke: "#D9D9D9",
    strokeWidth: 2.75,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4689 70.485C72.6274 64.0995 79.5754 60.287 87.0575 60.287C94.4892 60.287 101.413 64.0581 105.576 70.3773C96.1846 56.0352 76.4478 57.7873 68.4689 70.485Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5556 33.3132C63.5556 37.5013 66.9604 40.8965 71.1605 40.8965C75.3606 40.8965 78.7654 37.5013 78.7654 33.3132",
    stroke: "#D9D9D9",
    strokeWidth: 2.75,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0618 33.3132C95.0618 37.5013 98.4666 40.8965 102.667 40.8965C106.867 40.8965 110.272 37.5013 110.272 33.3132",
    stroke: "#D9D9D9",
    strokeWidth: 2.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoresult);
export default __webpack_public_path__ + "static/media/noresult.4a431e11f6a4d1d9980856105acad5a5.svg";
export { ForwardRef as ReactComponent };